import React from 'react';

import { Container } from './Group.styles';

type ButtonGroupProps = {
  /**
   * React children nodes
   */
  children: React.ReactNode;
  /**
   * Group alignment
   */
  alignment?: 'left' | 'right';
};

const ButtonGroup = ({ children, alignment = 'left' }: ButtonGroupProps) => (
  <Container
    gridGap="3"
    justifyContent={alignment === 'left' ? 'flex-start' : 'flex-end'}
  >
    {children}
  </Container>
);

export default ButtonGroup;
